import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export function Icon({ name = "globe", size = 22, ...props }) {
  const paths = {
    air: (
      <path d="M3 8h12a3 3 0 1 0-3-3M2 12h17a3 3 0 1 1-3 3M4 16h5a3 3 0 1 1-3 3" />
    ),
    climate: (
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2m0 16v2M2 12h2m16 0h2M5 5l1.5 1.5m11 11L19 19M5 19l1.5-1.5m11-11L19 5" />
      </>
    ),
    flood: (
      <path d="M2 7c3-4 5 4 8 0s5 4 8 0 4 0 4 0M2 12c3-4 5 4 8 0s5 4 8 0 4 0 4 0M2 17c3-4 5 4 8 0s5 4 8 0 4 0 4 0" />
    ),
    veg: <path d="M20 3C7 1 1 10 8 16s15-3 12-13ZM4 21 15 10M9 16v-5m0 5h5" />,
    drought: <path d="m12 2 6 9a7 7 0 1 1-12 0l6-9ZM12 10l-2 4 4 2-2 4" />,
    arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="4" ry="9" />
        <path d="M3 12h18M5 6.5c4 2 10 2 14 0M5 17.5c4-2 10-2 14 0" />
      </>
    ),
    clock: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 6v6l4 2" />
      </>
    ),
    check: <path d="m5 12 4 4L19 6" />,
    layers: (
      <path d="m12 3 10 5-10 5L2 8l10-5ZM2 12l10 5 10-5M2 16l10 5 10-5" />
    ),
    pin: (
      <>
        <path d="M19 10c0 5-7 11-7 11S5 15 5 10a7 7 0 1 1 14 0Z" />
        <circle cx="12" cy="10" r="2" />
      </>
    ),
    menu: <path d="M4 6h16M4 12h16M4 18h16" />,
    close: <path d="m5 5 14 14M5 19 19 5" />,
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths[name] || paths.globe}
    </svg>
  );
}

export function Brand() {
  return (
    <Link to="/" className="site-logo" aria-label="AirVista home">
      <span className="brand-mark">
        <Icon name="globe" size={25} />
      </span>
      <span>
        Air<span className="brand-accent">Vista</span>
      </span>
    </Link>
  );
}

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname, location.hash]);
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to content
      </a>
      <header className="site-header">
        <div className="site-nav site-container">
          <Brand />
          <nav
            className={`site-nav-links ${open ? "is-open" : ""}`}
            id="primary-navigation"
            aria-label="Main navigation"
          >
            <NavLink to="/" end>
              Overview
            </NavLink>
            <NavLink to="/modules">Explore modules</NavLink>
            <NavLink to="/about">About AirVista</NavLink>
          </nav>
          <Link className="nav-launch" to="/monitor">
            Open monitor <Icon name="arrow" size={17} />
          </Link>
          <button
            className="nav-toggle"
            aria-label={open ? "Close navigation" : "Open navigation"}
            aria-expanded={open}
            aria-controls="primary-navigation"
            onClick={() => setOpen(!open)}
            onKeyDown={(event) => {
              if (event.key === "Escape") setOpen(false);
            }}
          >
            <Icon name={open ? "close" : "menu"} />
          </button>
        </div>
      </header>
    </>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-container footer-main">
        <div className="footer-brand">
          <Brand />
          <p>
            A clearer view of our changing environment.
            <br />
            Built with open environmental data.
          </p>
          <a className="footer-contact" href="mailto:irfan.koreshe@gmail.com">
            Get in touch <Icon name="arrow" size={16} />
          </a>
        </div>
        <div>
          <h2>Explore</h2>
          <Link to="/monitor">Environmental monitor</Link>
          <Link to="/modules">Five modules</Link>
          <Link to="/modules#data">Sources & methodology</Link>
        </div>
        <div>
          <h2>AirVista</h2>
          <Link to="/about">About the project</Link>
          <a
            href="https://www.linkedin.com/in/irfan-mahmood-10b60144"
            target="_blank"
            rel="noopener noreferrer"
          >
            Meet the creator ↗
          </a>
          <a href="mailto:irfan.koreshe@gmail.com">Contact</a>
        </div>
      </div>
      <div className="site-container footer-bottom">
        <span>
          © {new Date().getFullYear()} AirVista · Created by Irfan Mahmood
        </span>
        <span>Model estimates. Clear sources. Local context matters.</span>
      </div>
    </footer>
  );
}
